/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* i(f, o) {
  if (f !== void 0) {
    let t = 0;
    for (const e of f)
      yield o(e, t++);
  }
}
export {
  i as e
};
